import 'jquery.cookie';
// https://www.npmjs.com/package/jquery.cookie

class CookieBarEu {

    constructor(config) {
        this.config = Object.assign({
            scope: '#eu-banner-outer',
            cookieName: 'wweu_cookie_pref',
        }, config);

        this.init();
    }

    init() {
        if (typeof jQuery.cookie(this.config.cookieName) == 'undefined') {
            this.createCookieBanner();
            this.setEvents();
        }
    }

    setEvents() {
        jQuery('body').on('click', this.config.scope + ' button#eu-settings-button', this.createCookieSettingsWindow.bind(this));
        jQuery('body').on('click', this.config.scope + ' button#eu-cookiemodal-close-button', this.closeCookieSettingsWindow.bind(this));
        jQuery('body').on('click', this.config.scope + ' button.eu-cookiecategory-label', this.toggleCookieSettingsWindowGroups.bind(this));
        jQuery('body').on('click', this.config.scope + ' input.eu-cookietoggle-switch-input', this.inputCookieToggle.bind(this));
        jQuery('body').on('click', this.config.scope + ' #eu-cookiemodal-footer-container > button, ' + this.config.scope + ' button#eu-confirmation-button', this.savePreferenceInCookie.bind(this));
    }

    savePreferenceInCookie(event) {
        event.preventDefault();
        let target = event.currentTarget;
        jQuery.cookie(this.config.cookieName,1, { expires: 365, path: '/' });

        let groups = ['analytics','functionality','advertisement'];
        if (jQuery(target).attr('id') == 'eu-confirmation-button') {
            // alle accepted
            jQuery(groups).each((it, el) => {
                jQuery.cookie('wweu_' + el, 'allow', {expires: 365, path: '/'});
            });
        } else {
            jQuery(groups).each((it, el) => {
                if (jQuery(this.config.scope).find('#eu-cookiecategory-toggle-' + el).length > 0 && jQuery(this.config.scope).find('#eu-cookiecategory-toggle-' + el).is(':checked')) {
                    jQuery.cookie('wweu_' + el, 'allow', {expires: 365, path: '/'});
                }
            });
        }
        jQuery(this.config.scope).remove();
        this.setGoogleConsent();
    }

    setGoogleConsent() {
        // https://help.cookie-script.com/en/google-analytics/google-consent-mode-implementation-instructions
        const consentMode = {
            'ad_storage': typeof jQuery.cookie('wweu_advertisement') == 'undefined' ? 'denied' : 'granted',
            'ad_user_data': typeof jQuery.cookie('wweu_advertisement') == 'undefined' ? 'denied' : 'granted',
            'ad_personalization': typeof jQuery.cookie('wweu_advertisement') == 'undefined' ? 'denied' : 'granted',
            'analytics_storage': typeof jQuery.cookie('wweu_analytics') == 'undefined' ? 'denied' : 'granted',
            'functionality_storage': typeof jQuery.cookie('wweu_functionality') == 'undefined' ? 'denied' : 'granted',
            'personalization_storage': typeof jQuery.cookie('wweu_functionality') == 'undefined' ? 'denied' : 'granted',
            'wait_for_update': 500
        }; 
        console.log(consentMode);
        try {
            gtag('consent', 'update', consentMode);
        } catch (error) {
            // no gtag available
            console.log('No gtag object available');
        }
        localStorage.setItem('consentMode', JSON.stringify(consentMode));
    }

    inputCookieToggle(event) {
        let target = event.currentTarget;
        jQuery(target).parent('.eu-cookietoggle-switch').toggleClass('selected');
    }

    closeCookieSettingsWindow(event) {
        event.preventDefault();
        jQuery(this.config.scope).find('div#eu-cookiemodal').remove();
    }

    toggleCookieSettingsWindowGroups(event) {
        event.preventDefault();
        let target = event.currentTarget;
        jQuery(target).parent().next().toggleClass('visible');
    }

    createCookieSettingsWindow() {
        let html = `<div id="eu-cookiemodal" data-nosnippet="true">
            <div id="eu-cookiemodal-content" role="alertdialog" aria-modal="true" aria-labelledby="eu-cookiemodal-introduction" aria-describedby="eu-cookiemodal-introduction-description" tabindex="0">
                <div id="eu-cookiemodal-header">
                    <div id="eu-cookiemodal-header-container">
                        <button id="eu-cookiemodal-close-button" class="eu-cookieclose-button" tabindex="0" aria-label="Close modal">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32">
                                <path fill="currentColor" d="M4.3,27.7c0.2,0.2,0.6,0.5,1,0.5c0.4,0,0.8-0.2,1-0.5l9.6-9.5l9.6,9.5c0.2,0.2,0.6,0.5,1,0.5 c0.8,0,1.5-0.6,1.5-1.5c0-0.4-0.2-0.8-0.5-1L18.2,16l9.5-9.5c0.2-0.2,0.4-0.6,0.4-1c0-0.8-0.6-1.5-1.5-1.5c-0.4,0-0.7,0.2-1,0.4l0,0 L16,13.8L6.5,4.3C6.2,4,5.8,3.8,5.4,3.8c-0.8,0-1.5,0.6-1.5,1.5c0,0.5,0.2,0.8,0.5,1.1l0,0l9.5,9.5l-9.5,9.6c-0.2,0.2-0.5,0.6-0.5,1 S4.1,27.4,4.3,27.7L4.3,27.7z">
                                </path>
                            </svg>
                        </button>
                    </div>
                </div>
                <div id="eu-cookiemodal-body">
                    <div id="eu-cookiemodal-body-container">
                        <div id="eu-cookiemodal-introduction">
                            <span>` + this.config.text.cookiemodal.heading + `
                            </span>
                        </div>
                        <div id="eu-cookiemodal-introduction-description">
                             ` + this.config.text.cookiemodal.intro + `
                        </div>
                        <div id="eu-cookiecategories-container">
                            <div class="eu-cookiecategory-row">
                                <div class="eu-cookiecategory-row-header">
                                    <button id="eu-cookiecategory-necessary" class="eu-cookiecategory-label" aria-expanded="false" aria-controls="eu-cookiecategory-description-necessary" tabindex="0">
                                        <svg version="1.1" id="plus-icon-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" class="description-accordion-arrow ">
                                            <path fill="currentColor" d="M22.6,15.3c-0.1-0.1-0.1-0.2-0.2-0.2l0,0l-0.1-0.2l0,0l0,0l0,0L12.1,4.2c-0.2-0.2-0.6-0.5-1.1-0.5 c-0.9,0-1.5,0.7-1.5,1.5c0,0.4,0.2,0.7,0.4,1l0,0l9.3,9.7l-9.3,9.7c-0.3,0.3-0.6,0.7-0.6,1.1c0,0.9,0.7,1.5,1.5,1.5 c0.5,0,1-0.2,1.2-0.6l0,0l10.2-10.7l0,0l0,0l0,0l0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2l0,0c0-0.1,0.1-0.2,0.1-0.2l0,0 c0-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0v-0.1C22.6,15.5,22.6,15.4,22.6,15.3L22.6,15.3L22.6,15.3z">
                                            </path>
                                        </svg>
                                        <span>` + this.config.text.cookiemodal.category.necessary.label + `</span>
                                    </button>
                                    <span class="eu-cookiealways-active-label" tabindex="0" aria-label="Altijd actief">` + this.config.text.cookiemodal.category.necessary.label2 + `
                                    </span>
                                </div>
                                <div class="eu-cookiecategory-description " id="eu-cookiecategory-description-necessary" tabindex="0">
                                    ` + this.config.text.cookiemodal.category.necessary.text + `
                                </div>
                            </div>
                            `
        if (this.config.text.cookiemodal.category.analytics.text != "") {
            html += `
                                <div class="eu-cookiecategory-row">
                                    <div class="eu-cookiecategory-row-header">
                                        <button id="eu-cookiecategory-analytics" class="eu-cookiecategory-label" aria-expanded="false" aria-controls="eu-cookiecategory-description-analytics" tabindex="0">
                                            <svg version="1.1" id="plus-icon-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" class="description-accordion-arrow ">
                                                <path fill="currentColor" d="M22.6,15.3c-0.1-0.1-0.1-0.2-0.2-0.2l0,0l-0.1-0.2l0,0l0,0l0,0L12.1,4.2c-0.2-0.2-0.6-0.5-1.1-0.5 c-0.9,0-1.5,0.7-1.5,1.5c0,0.4,0.2,0.7,0.4,1l0,0l9.3,9.7l-9.3,9.7c-0.3,0.3-0.6,0.7-0.6,1.1c0,0.9,0.7,1.5,1.5,1.5 c0.5,0,1-0.2,1.2-0.6l0,0l10.2-10.7l0,0l0,0l0,0l0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2l0,0c0-0.1,0.1-0.2,0.1-0.2l0,0 c0-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0v-0.1C22.6,15.5,22.6,15.4,22.6,15.3L22.6,15.3L22.6,15.3z">
                                                </path>
                                            </svg>
                                            <span>` + this.config.text.cookiemodal.category.analytics.label + `</span>
                                        </button>
                                        <div class="eu-cookietoggle-switch ">
                                            <div class="eu-cookietoggle-switch-nob">
                                            </div>
                                            <input id="eu-cookiecategory-toggle-analytics" class="eu-cookietoggle-switch-input" type="checkbox" aria-pressed="false" tabindex="0" aria-describedby="eu-cookiecategory-toggle-analytics-help-text" data-test-id="eu-cookiecategory-toggle-analytics">
                                        </div>
                                    </div>
                                    <div class="eu-cookiecategory-description " id="eu-cookiecategory-description-analytics" tabindex="0">
                                        ` + this.config.text.cookiemodal.category.analytics.text + `
                                    </div>
                                </div>
                                `
        }
        if (this.config.text.cookiemodal.category.advertisement.text != "") {
            html += `
                                <div class="eu-cookiecategory-row">
                                    <div class="eu-cookiecategory-row-header">
                                        <button id="eu-cookiecategory-advertisement" class="eu-cookiecategory-label" aria-expanded="false" aria-controls="eu-cookiecategory-description-advertisement" tabindex="0">
                                            <svg version="1.1" id="plus-icon-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" class="description-accordion-arrow ">
                                                <path fill="currentColor" d="M22.6,15.3c-0.1-0.1-0.1-0.2-0.2-0.2l0,0l-0.1-0.2l0,0l0,0l0,0L12.1,4.2c-0.2-0.2-0.6-0.5-1.1-0.5 c-0.9,0-1.5,0.7-1.5,1.5c0,0.4,0.2,0.7,0.4,1l0,0l9.3,9.7l-9.3,9.7c-0.3,0.3-0.6,0.7-0.6,1.1c0,0.9,0.7,1.5,1.5,1.5 c0.5,0,1-0.2,1.2-0.6l0,0l10.2-10.7l0,0l0,0l0,0l0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2l0,0c0-0.1,0.1-0.2,0.1-0.2l0,0 c0-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0v-0.1C22.6,15.5,22.6,15.4,22.6,15.3L22.6,15.3L22.6,15.3z">
                                                </path>
                                            </svg>
                                            <span>` + this.config.text.cookiemodal.category.advertisement.label + `</span>
                                        </button>
                                        <div class="eu-cookietoggle-switch ">
                                            <div class="eu-cookietoggle-switch-nob">
                                            </div>
                                            <input id="eu-cookiecategory-toggle-advertisement" class="eu-cookietoggle-switch-input" type="checkbox" aria-pressed="false" tabindex="0" aria-describedby="eu-cookiecategory-toggle-advertisement-help-text" data-test-id="eu-cookiecategory-toggle-advertisement">
                                        </div>
                                    </div>
                                    <div class="eu-cookiecategory-description " id="eu-cookiecategory-description-advertisement" tabindex="0">
                                        ` + this.config.text.cookiemodal.category.advertisement.text + `
                                    </div>
                                </div>
                                `
        }
        if(this.config.text.cookiemodal.category.functionality.text != "") {
            html += `
                                <div class="eu-cookiecategory-row">
                                    <div class="eu-cookiecategory-row-header">
                                        <button id="eu-cookiecategory-functionality" class="eu-cookiecategory-label" aria-expanded="false" aria-controls="eu-cookiecategory-description-functionality" tabindex="0">
                                            <svg version="1.1" id="plus-icon-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" class="description-accordion-arrow ">
                                                <path fill="currentColor" d="M22.6,15.3c-0.1-0.1-0.1-0.2-0.2-0.2l0,0l-0.1-0.2l0,0l0,0l0,0L12.1,4.2c-0.2-0.2-0.6-0.5-1.1-0.5 c-0.9,0-1.5,0.7-1.5,1.5c0,0.4,0.2,0.7,0.4,1l0,0l9.3,9.7l-9.3,9.7c-0.3,0.3-0.6,0.7-0.6,1.1c0,0.9,0.7,1.5,1.5,1.5 c0.5,0,1-0.2,1.2-0.6l0,0l10.2-10.7l0,0l0,0l0,0l0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2l0,0c0-0.1,0.1-0.2,0.1-0.2l0,0 c0-0.1,0.1-0.2,0.1-0.3l0,0c0-0.1,0-0.2-0.1-0.3l0,0v-0.1C22.6,15.5,22.6,15.4,22.6,15.3L22.6,15.3L22.6,15.3z">
                                                </path>
                                            </svg>
                                            <span>
                                            ` + this.config.text.cookiemodal.category.functionality.label + `
                                            </span>
                                        </button>
                                        <div class="eu-cookietoggle-switch ">
                                            <div class="eu-cookietoggle-switch-nob">
                                            </div>
                                            <input id="eu-cookiecategory-toggle-functionality" class="eu-cookietoggle-switch-input" type="checkbox" aria-pressed="false" tabindex="0" aria-describedby="eu-cookiecategory-toggle-functionality-help-text" data-test-id="eu-cookiecategory-toggle-functionality">
                                        </div>
                                    </div>
                                    <div class="eu-cookiecategory-description " id="eu-cookiecategory-description-functionality" tabindex="0">
                                        ` + this.config.text.cookiemodal.category.functionality.text + `
                                    </div>
                                </div>
                                `
        }
        html += `
                        </div>
                    </div>
                </div>
                <div id="eu-cookiemodal-footer">
                    <div id="eu-cookiemodal-footer-container">
                        <button id="eu-cookiemodal-accept-all" class="btn btn-primary" tabindex="0">` + this.config.text.cookiemodal.footer.buttons.accept + `</button>
                        <button id="eu-cookiemodal-save-settings" class="btn btn-outline-primary" tabindex="0">` + this.config.text.cookiemodal.footer.buttons.save + `</button>
                    </div>
                </div>
            </div>
        </div>`;
        jQuery(this.config.scope).append(html);
    }

    createCookieBanner() {
        let html = `<div id="eu-banner-outer">
            <div id="eu-cookie-confirmation" role="dialog" aria-describedby="eu-policy-wording" aria-label="Cookie banner" tabindex="0">
                <div id="eu-cookie-inner">
                    ` + this.config.text.common + `
                    <div id="eu-cookie-buttons-area">
                        <button id="eu-settings-button" aria-label="Cookie-instellingen" tabindex="0">` + this.config.buttonText.settings + `</button>
                        <button id="eu-confirmation-button" class="btn btn-primary" aria-label="Alles accepteren" tabindex="0">` + this.config.buttonText.accept + `</button>
                    </div>
                </div>
           </div>
        </div>`;
        jQuery('body').append(html);
    }

}

export default CookieBarEu;

